import { Fragment, Suspense, useLayoutEffect } from 'react';
import { LayoutProps } from './layout.types';
import { Container, GlobalStyles } from './styles';
import Header from '@/shared/components/layout/components/header';
import LayoutSidebar from '@/shared/components/layout/components/sidebar/sidebar';
import ErrorBoundary from '@/shared/components/error-boundary';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';
import { Outlet } from 'react-router-dom';
import { Layout as UILayout } from '@metaicg/sensei-ui';
import useStorage from '@/shared/hooks/use-storage';
import useAuth from '@/features/auth/hooks/use-auth';

const Layout = ({
  children,
  showMenu = false,
  showHeader = true,
  showLogo = true,
  publicRoute = false,
}: LayoutProps) => {
  const { t } = useTranslation();
  const { store } = useStorage();
  const { logout } = useAuth();

  useLayoutEffect(() => {
    let isMounted = true;

    (async () => {
      const auth = await store.getAuth();
      if (!auth && !publicRoute) {
        if (isMounted) {
          await logout();
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [store, logout, publicRoute]);

  return (
    <Container>
      <GlobalStyles />
      <UILayout header={showHeader && <Header showLogo={showLogo} />} sidebar={showMenu && <LayoutSidebar />}>
        <Suspense fallback={null}>
          <ErrorBoundary title={t('common:messages.error.generic')}>
            <AnimatePresence mode="wait">
              <Fragment>{children || <Outlet />}</Fragment>
            </AnimatePresence>
          </ErrorBoundary>
        </Suspense>
      </UILayout>
    </Container>
  );
};

export default Layout;
